// Dependecies
import { memo } from "react";

// Assets
import "./styles.scss";

export const Footer = memo(() => (
  <div className="Footer">Últimos cambios en la web: 09/02/2023 - v1.0.4</div>
));
